import React, { useState, useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";
import { LanguageContext } from "../contexts/LanguageContext"; // Dil çevirileri için context
import logo from "../assets/images/logo.png";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";

const SignUpPage = () => {
  const { signUp } = useContext(AuthContext);
  const { translations } = useContext(LanguageContext); // Dil çevirileri
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
    termsAccepted: false,
  });
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false); // Modal görünürlüğü için state
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.password !== formData.confirmPassword) {
      setErrorMessage(translations.passwordsDoNotMatch);
      return;
    }

    setLoading(true);
    const response = await signUp(formData);
    setLoading(false);

    if (response.success) {
      navigate("/chat/verification", { state: { message: formData.email } });
    } else {
      setErrorMessage(response.message);
    }
  };

  return (
    <div className="container-fluid vh-100 d-flex align-items-center justify-content-center bg-light">
      <div className="row w-100 h-100">
        {/* Sol Panel */}
        <div className="col-lg-6 d-none d-lg-flex flex-column align-items-center justify-content-center text-white bg-dark">
          <h1 className="display-4 fw-bold">{translations.joinCommunity}</h1>
          <p className="text-center px-4">{translations.createAccountSubtitle}</p>
        </div>

        {/* Sağ Panel */}
        <div className="col-lg-6 d-flex flex-column align-items-center justify-content-center">
          <div className="text-center mb-4">
            <img src={logo} alt="Company Logo" style={{ maxWidth: "150px" }} className="img-fluid" />
          </div>
          <div className="card p-4 shadow" style={{ maxWidth: "500px", width: "100%" }}>
            <h2 className="text-center mb-4">{translations.signUpTitle}</h2>
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label htmlFor="firstName" className="form-label">
                  {translations.firstNameLabel}
                </label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  className="form-control"
                  placeholder={translations.firstNamePlaceholder}
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label htmlFor="lastName" className="form-label">
                  {translations.lastNameLabel}
                </label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  className="form-control"
                  placeholder={translations.lastNamePlaceholder}
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label htmlFor="email" className="form-label">
                  {translations.emailLabel}
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  className="form-control"
                  placeholder={translations.emailPlaceholder}
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label htmlFor="phone" className="form-label">
                  {translations.phoneLabel}
                </label>
                <input
                  type="text"
                  id="phone"
                  name="phone"
                  className="form-control"
                  placeholder={translations.phonePlaceholder}
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label htmlFor="password" className="form-label">
                  {translations.passwordLabel}
                </label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  className="form-control"
                  placeholder={translations.passwordPlaceholder}
                  value={formData.password}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label htmlFor="confirmPassword" className="form-label">
                  {translations.confirmPasswordLabel}
                </label>
                <input
                  type="password"
                  id="confirmPassword"
                  name="confirmPassword"
                  className="form-control"
                  placeholder={translations.confirmPasswordPlaceholder}
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3 form-check">
                <input
                  type="checkbox"
                  id="termsAccepted"
                  name="termsAccepted"
                  className="form-check-input"
                  checked={formData.termsAccepted}
                  onChange={handleChange}
                  required
                />
                <label htmlFor="termsAccepted" className="form-check-label">
                  {translations.termsAndConditions}&nbsp;
                  <button
                    type="button"
                    className="btn btn-link p-0"
                    onClick={() => setShowModal(true)}
                  >
                    {translations.termsLink}
                  </button>
                </label>
              </div>
              {errorMessage && (
                <div className="alert alert-danger text-center">{errorMessage}</div>
              )}
              <button type="submit" className="btn btn-primary w-100" disabled={loading}>
                {loading ? translations.signingUp : translations.signUpButton}
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{translations.modalTitle}</h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)} />
              </div>
              <div className="modal-body">
                <p>{translations.condition}</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  {translations.close}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SignUpPage;